import { render } from "lit-html";

class ZhiForm extends HTMLElement {

  _loading = false;

  get loading() {
    return this._loading;
  }

  set loading(newValue) {
    if (newValue === this._loading) return;
    this._loading = newValue;
    if (newValue === true) {
      this.renderLoader();
    } else {
      this.removeLoader();
    }
  } 

  get formFields() {
   return Array.from(this.querySelectorAll(".zhi-form-field"));
  }

  get submitUrl() {
    return this.getAttribute("submit-url") || undefined;
  }

  get recipientMail() {
    return this.getAttribute("recipient-mail") || "dev@riewerts.io";
  }

  get submitData() {
    return this.formFields.map(formField => formField.submitData).filter(data => data !== null);
  }

  get subject() {
    return this.getAttribute("subject") || "Neue Nachricht über das Kontaktformular";
  }

  get fromData() {
    const submitData = this.submitData;
    const nameData = submitData.find(data => data.name === "name");
    const emailData = submitData.find(data => data.name === "mail");

    if (nameData === undefined || emailData === undefined) return {
      name: "Anonym",
      mail: "no-reply@zimmerei-hinrichsen.de",
    };

    return {
      name: nameData.value,
      mail: emailData.value,
    };
  }

  get toData() {
    return {
      name: "Zimmerei Hinrichsen",
      mail: this.recipientMail,
    };
  }

  constructor() {
    super();
    this.addEventListener("submit", this.submitForm.bind(this));
  }

  validateFormFields() {
    let formIsValid = true;
    this.formFields.forEach(formField => {
      formField.validate();
      formIsValid = formIsValid && formField.isValid;
    });
    return formIsValid;
  }

  async submitForm(e) {
    e.preventDefault();
    if (this.loading === true) return;

    const formIsValid = this.validateFormFields();
    if (formIsValid === false) return;
    
    this.loading = true;
    await this.postData();
  }

  async postData() {
    if (this.submitUrl === undefined) return;
    
    const submitData = this.submitData;
    if (submitData.length === 0) return;

    const mailData = {
      from: this.fromData,
      to: this.toData,
      subject: this.subject,
      formData: submitData,
    };

    try {
      const response = await fetch(this.submitUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mailData),
      });

      if (response.ok === false) {
        throw new Error(`HTTP-Error: ${response.status}`);
      }

      this.handleSuccess();

    } catch (error) {
      console.error(error);
      this.handleError();
    }
  }

  handleSuccess() {
    this.loading = false;
    this.classList.add("zhi-state-success");
  }

  handleError() {
    this.loading = false;
    this.classList.add("zhi-state-error");
  }

  renderLoader() {
    this.classList.add("zhi-state-loading");
    this.loader = document.createElement("div");
    this.loader.classList.add("zhi-form__loader");

    const loaderBounce1 = document.createElement("div");
    loaderBounce1.classList.add("zhi-form__loader-bounce");

    const loaderBounce2 = document.createElement("div");
    loaderBounce2.classList.add("zhi-form__loader-bounce");

    this.loader.appendChild(loaderBounce1);
    this.loader.appendChild(loaderBounce2);

    this.appendChild(this.loader);
  }

  removeLoader() {
    if (this.loader === undefined) return;
    this.removeChild(this.loader);
    this.loader = undefined;
  }
}

customElements.define("zhi-form", ZhiForm);